import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",attrs:{"id":"tfooter"}},[_vm._t("footer",function(){return [_c('div',{staticClass:"font-12 text-gray-800"},[_vm._t("footer.prepend")],2),_c(VSpacer),_c('div',{staticClass:"font-12 text-gray-800"},[_vm._t("footer.append")],2),_c('span',{staticClass:"font-12 text-gray-800 py-2 pr-3 pl-3"},[_vm._v("Total de Itens: "+_vm._s(_vm.Helpers.formatarValor(_vm.countItems)))])]},{"countItems":_vm.countItems})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }